import PropTypes from "prop-types";

const fitTag = (content, i) => (
  <div key={i} className="bg-offWhite w-fit rounded py-2 px-3 capitalize">
    {content}
  </div>
);

export default function FitFeedbackTags({ review }) {
  if (!review) return null;

  const formatFitFeedback = (key, value) => {
    if (key === "Overall Fit") {
      return value === "Just right" ? "True to Size" : value;
    } else if (key === "Length") {
      return value === "Just right" ? `${value} in Length` : value;
    } else {
      let newValue = value;
      if (value.includes("Runs ")) {
        newValue = value.replace("Runs ", "");
      }
      return `${newValue} in ${key}`;
    }
  };

  const renderFitTags = feedbackMap =>
    Object.entries(feedbackMap).map(([key, value], i) => fitTag(formatFitFeedback(key, value), i));

  const renderFitFeedbackWrapper = children => (
    <div className="mb-8">
      <p className="text-darkGray mb-2">Fit Feedback</p>
      <div className="flex flex-wrap gap-2 mt-2">{children}</div>
    </div>
  );

  if (review.fitFeedbackMap && Object.keys(review.fitFeedbackMap).length > 0) {
    return renderFitFeedbackWrapper(renderFitTags(review.fitFeedbackMap));
  } else if (review.fit) {
    const fitContent = review.fit === "Small" ? "Runs Small" : review.fit === "Large" ? "Runs Large" : review.fit;
    return renderFitFeedbackWrapper([fitTag(fitContent, 0)]);
  }

  return null;
}

FitFeedbackTags.propTypes = {
  review: PropTypes.object,
};
